import React from 'react';
const GOLD = '#C9A84C';
const tabs = [
  { id: 'pos', icon: '🧾', label: 'POS' },
  { id: 'members', icon: '👥', label: 'Members' },
  { id: 'inventory', icon: '📦', label: 'Inventory' },
  { id: 'reports', icon: '📊', label: 'Revenue Intel' },
  { id: 'marketing', icon: '📣', label: 'Mktg' },
  { id: 'settings', icon: '⚙️', label: 'Admin' },
];
export default function BottomNav({ activeTab, onChange }) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      height: 'calc(56px + env(safe-area-inset-bottom))',
      background: '#111', borderTop: '1px solid #2A2A2A',
      display: 'flex', alignItems: 'flex-start', zIndex: 900,
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {tabs.map(t => (
        <button key={t.id} onClick={() => onChange(t.id)} style={{
          flex: 1, background: 'none', border: 'none', padding: '8px 0',
          color: activeTab === t.id ? GOLD : '#666', cursor: 'pointer',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
        }}>
          <span style={{ fontSize: 20 }}>{t.icon}</span>
          <span style={{ fontSize: 9, letterSpacing: 0.5 }}>{t.label}</span>
        </button>
      ))}
    </div>
  );
}
